.chatMarkdown :where(p) {
  margin-top: 0;
  margin-bottom: 0.25rem;
}

.chatMarkdown :where(p:last-child) {
  margin-bottom: 0;
}

.chatMarkdown :where(ul, ol) {
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
  padding-left: 1.25rem;
}

.chatMarkdown :where(ul li, ol li) {
  margin-bottom: 0.08rem;
}

.chatMarkdown :where(h1, h2, h3, h4, h5, h6) {
  margin-top: 0.75rem;
  margin-bottom: 0.35rem;
  font-size: 1.12rem;
  font-weight: 600;
}

.chatMarkdown :where(h2) {
  font-size: 1.05rem;
}

.chatMarkdown :where(h3) {
  font-size: 1rem;
}

.chatMarkdown :where(code) {
  font-size: 0.95em;
  font-weight: 500;
  color: inherit;
  padding: 0.12em 0.5em;
  border-radius: 6px;
}